import { Box, Table, TableBody, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSubscription } from 'services/hooks';
import { CrownIcon } from 'assets/icons';
import userApi from 'services/api/user';
import {
  StyledCrownAndTextContainer,
  StyledTableCell,
  StyledTableCellWide,
  StyledTableContainer,
  StyledTableHead,
  StyledTypography,
} from './styled';

const AccountLimitsTable = () => {
  const { t } = useTranslation();
  const { isFreeAccount } = useSubscription();

  const { data, isError } = userApi.useGetAccountLimitsQuery();

  if (isError) {
    return <Box>{t('account:subscription:limitsError')}</Box>;
  }

  return (
    <StyledTableContainer>
      <Table>
        <StyledTableHead>
          <TableRow>
            <StyledTableCellWide>
              {t('account:subscription:action')}
            </StyledTableCellWide>
            <StyledTableCell>
              {t('account:subscription:allowance')}
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {t('account:subscription:currentUsage')}
              </StyledTableCell>
            )}
          </TableRow>
        </StyledTableHead>
        <TableBody>
          <TableRow>
            <StyledTableCell>
              <StyledTypography>
                {t('account:subscription:aiTrackCreations')}
              </StyledTypography>
            </StyledTableCell>
            <StyledTableCell>
              <StyledTypography>
                {isFreeAccount
                  ? t('account:subscription:limited')
                  : data?.usageData.generateVegaSong.total || '-'}
              </StyledTypography>
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {data?.usageData.generateVegaSong.used ?? '-'}
              </StyledTableCell>
            )}
          </TableRow>
          <TableRow>
            <StyledTableCell>
              <StyledTypography>
                {t('account:subscription:trackDownloads')}
              </StyledTypography>
            </StyledTableCell>
            <StyledTableCell>
              <StyledTypography>
                {isFreeAccount
                  ? t('account:subscription:limited')
                  : data?.usageData.downloadSong.total || '-'}
              </StyledTypography>
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {data?.usageData.downloadSong.used ?? '-'}
              </StyledTableCell>
            )}
          </TableRow>
          <TableRow>
            <StyledTableCell>
              <StyledCrownAndTextContainer isFreeAccount={isFreeAccount}>
                {isFreeAccount && <CrownIcon />}
                <StyledTypography>
                  {t('account:subscription:stemPackDownloads')}
                </StyledTypography>
              </StyledCrownAndTextContainer>
            </StyledTableCell>
            <StyledTableCell>
              {data?.usageData.downloadStems.total || '-'}
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {data?.usageData.downloadStems.used ?? '-'}
              </StyledTableCell>
            )}
          </TableRow>
          <TableRow>
            <StyledTableCell>
              <StyledCrownAndTextContainer isFreeAccount={isFreeAccount}>
                {isFreeAccount && <CrownIcon />}
                <StyledTypography>
                  {t('account:subscription:samplePackDownloads')}
                </StyledTypography>
              </StyledCrownAndTextContainer>
            </StyledTableCell>
            <StyledTableCell>
              {data?.usageData.downloadSamplePack.total || '-'}
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {data?.usageData.downloadSamplePack.used ?? '-'}
              </StyledTableCell>
            )}
          </TableRow>
          <TableRow>
            <StyledTableCell>
              <StyledCrownAndTextContainer isFreeAccount={isFreeAccount}>
                {isFreeAccount && <CrownIcon />}
                <StyledTypography>
                  {t('account:subscription:tracksReleased')}
                </StyledTypography>
              </StyledCrownAndTextContainer>
            </StyledTableCell>
            <StyledTableCell>
              {data?.usageData.submitRelease.total || '-'}
            </StyledTableCell>
            {!isFreeAccount && (
              <StyledTableCell>
                {data?.usageData.submitRelease.used ?? '-'}
              </StyledTableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default AccountLimitsTable;
